import type { ReportTypeDefinition } from '../config/reportTypes';

/** Full registry description for cards — no first-sentence truncation. */
export function reportTypeTagline(
  type: Pick<ReportTypeDefinition, 'description' | 'shortLabel'>,
): string {
  const description = (type.description ?? '').trim();
  return description || `${type.shortLabel} assessment.`;
}
